/**
 * anlage-ballsets — Formatierer und Preis-Spalten der Vorschau.
 *
 * Eigene Datei, damit Seite und Komponenten dieselben Formate benutzen, ohne sich
 * gegenseitig zu importieren (`MainPage` → `VorschauKarten` → `MainPage` waere ein Ring).
 */

/** Deutsches Waehrungsformat — jeder Geldbetrag der Oberflaeche laeuft hier durch. */
export const eur = (n: number) =>
  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n);

/** Deutsches Zahlenformat fuer Mengen. IDs bleiben roh — eine Item-ID ist keine Menge. */
export const zahl = (n: number) => new Intl.NumberFormat('de-DE').format(n);

/**
 * Ein Zeitpunkt aus der Schnittstelle im deutschen Format — fehlt er oder ist er unlesbar,
 * steht ein Strich da statt „Invalid Date".
 *
 * Genau das stand am 14.08.2026 in der Historie von `herkunft-zuweisen`, weil das
 * Sequelize-Model das Attribut `createdAt` versehentlich in `created_at` umbenannt hatte.
 * Der Strich verraet den Fehler nicht, aber er macht die Seite nicht laecherlich.
 */
export const zeitpunkt = (wert: string | null | undefined, nurDatum = false): string => {
  if (!wert) return '—';
  const d = new Date(wert);
  if (isNaN(d.getTime())) return '—';
  return nurDatum ? d.toLocaleDateString('de-DE') : d.toLocaleString('de-DE');
};

/**
 * Ein Preis, der in der Antwort fehlt, wird als Strich gezeigt — nie als 0,00 €.
 * „Nicht gepflegt" und „kostet nichts" sind zwei verschiedene Aussagen, und die zweite
 * waere hier eine Erfindung: das Backend laesst fehlende Preise bewusst weg und warnt.
 */
export const eurOderStrich = (wert: number | null | undefined) =>
  wert === null || wert === undefined ? '—' : eur(wert);

/**
 * Die Preis-Spalten der Vorschau, in Anzeige-Reihenfolge.
 *
 * Die IDs sind der Spiegel von `backend/src/config.ts` (PREIS_WEBSHOP 1,
 * PREIS_MARKTPLAETZE 7, PREIS_KAUFLAND 29, PREIS_UVP 16, PREIS_AB_MENGE_4 18).
 * „ab Menge 4" steht nur an den Original-Varianten: es ist beim Spielball die Basis des
 * Webshop-Preises, wandert selbst aber nie in eine Set-Variante.
 */
export const PREIS_SPALTEN: Array<{ id: number; titel: string }> = [
  { id: 1, titel: 'Webshop' },
  { id: 7, titel: 'Marktplätze' },
  { id: 29, titel: 'Kaufland' },
  { id: 16, titel: 'UVP' },
];

/** Zusatz-Spalte nur fuer die Original-Tabelle. */
export const PREIS_AB_MENGE_4 = { id: 18, titel: 'ab Menge 4' };
